import { ProgressBar } from './ProgressBar';

export type CategoryItem = { id: string; name: string; color: string; value: number };

/** Gastos por categoria (`.catrow` + barra), proporcionais a `max`. */
export function CategoryBars({ items, max = Math.max(0, ...items.map((i) => i.value)), format }: { items: CategoryItem[]; max?: number; format: (v: number) => string }) {
  return (
    <>
      {items.map((c) => (
        <div className="catrow" key={c.id}>
          <div className="top">
            <span><i style={{ background: c.color }} />{c.name}</span>
            <b>{format(c.value)}</b>
          </div>
          <ProgressBar value={max > 0 ? c.value / max : 0} color={c.color} label={`${c.name}: ${format(c.value)}`} />
        </div>
      ))}
    </>
  );
}
